import { registerTour } from "../tourRegistry";

function getSteps() {
  const totalSteps = 4;
  const stepCounter = (n) => `Step ${n} of ${totalSteps}`;

  return [
    {
      id: 'sub-overview',
      title: `Subscription Management <span class="t3-shepherd-step-count">${stepCounter(1)}</span>`,
      text: 'Manage your T3 Books subscriptions here. Assign or remove licenses from your organizations and adjust quantities.',
      attachTo: { element: '[data-tour="sub-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'sub-org-list',
      title: `Your Organizations <span class="t3-shepherd-step-count">${stepCounter(2)}</span>`,
      text: 'Each card represents an organization. Green borders mean an active license is assigned. Dashed borders indicate a pending change that hasn\'t been saved yet.',
      attachTo: { element: '[data-tour="sub-org-list"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'sub-quantity',
      title: `Adjust Licenses <span class="t3-shepherd-step-count">${stepCounter(3)}</span>`,
      text: 'Use the + and \u2212 buttons to assign or remove licenses. Changes are shown as \u2018pending\u2019 until you save. This lets you review all changes before committing.',
      attachTo: { element: '[data-tour="sub-quantity"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'sub-save',
      title: `Save Changes <span class="t3-shepherd-step-count">${stepCounter(4)}</span>`,
      text: 'When you\'re ready, save your changes. For changes that remove licenses, you\'ll be asked to confirm with a slide-to-confirm gesture to prevent accidental removals.',
      attachTo: { element: '[data-tour="sub-save"]', on: 'top' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'subscription',
  pathPattern: '/account/subscriptions',
  getSteps,
  label: 'Subscription Management Tour',
});
